import { createElement } from 'react'
import { Table } from 'shared/components'
import { TargetEventColumn } from './components/targetEventColumn'
import { ContributorColumn } from './components/contributorColumn'

function createContributorColumn({ value }) {
  return createElement(ContributorColumn, { value })
}

function createTargetEvent({ value }) {
  return createElement(TargetEventColumn, { value })
}

export const createColumns = () => [
  {
    Header: 'Status',
    accessor: 'state',
    minWidth: 104,
    width: 104,
  },
  {
    Header: 'Trigger',
    accessor: 'triggerDTO.description',
    minWidth: 240,
    width: 240,
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    minWidth: 80,
    width: 80,
  },
  {
    Header: 'Contributors',
    accessor: 'contributorsAmount',
    minWidth: 104,
    width: 104,
  },
  {
    Header: 'Contributors Name',
    accessor: 'contributors',
    Cell: createContributorColumn,
    minWidth: 280,
    width: 280,
  },
  {
    Header: 'Created',
    accessor: 'date',
    Cell: Table.CellRenderers.DateTimeCell,
    minWidth: 180,
    width: 180,
  },
  {
    Header: 'Target Event',
    accessor: 'triggerDTO',
    Cell: createTargetEvent,
  },
  {
    Header: 'Target Beneficiary',
    accessor: 'beneficiaryDTO.beneficiaryName',
  },
]
